"use client";

import { SKILL_ICON_MAP, type SkillIconKey } from "@/lib/skill-icon-map";
import type { PublicSkillItem } from "@/lib/services/skill.service";

type CoreStackMarqueeProps = {
	items: PublicSkillItem[];
};

export default function CoreStackMarquee({ items }: CoreStackMarqueeProps) {
	const repeated = [...items, ...items];

	return (
		<div className="relative overflow-hidden">
			<div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-[#0b0d12] to-transparent" />
			<div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-[#0b0d12] to-transparent" />

			<div className="flex w-max gap-10 py-2 motion-safe:animate-[corestack-marquee_26s_linear_infinite] hover:[animation-play-state:paused]">
				{repeated.map((skill, index) => {
					const canRenderIcon =
						skill.type === "icon" && skill.icon && skill.icon in SKILL_ICON_MAP;
					const Icon = canRenderIcon
						? SKILL_ICON_MAP[skill.icon as SkillIconKey]
						: null;

					return (
						<div
							key={`${skill.id}-${index}`}
							className="flex w-[5.5rem] shrink-0 flex-col items-center text-center"
						>
							<div className="flex h-14 w-full items-center justify-center">
								{Icon ? (
									<Icon
										className="h-11 w-11"
										style={{ color: skill.color || "#e5e7eb" }}
									/>
								) : skill.type === "image" && skill.imageUrl ? (
									<img
										src={skill.imageUrl}
										alt={skill.title}
										className="h-11 w-11 object-contain"
										loading="lazy"
									/>
								) : (
									<div className="h-11 w-11" />
								)}
							</div>
							<p className="mt-2 text-[0.75rem] leading-none text-zinc-200">
								{skill.title}
							</p>
						</div>
					);
				})}
			</div>

			<style jsx>{`
				@keyframes corestack-marquee {
					from {
						transform: translateX(0);
					}
					to {
						transform: translateX(-50%);
					}
				}
			`}</style>
		</div>
	);
}

